import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = { class: "button mb-4" }
const _hoisted_5 = { class: "row row-layout mb-4" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "row row-text align-items-center" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "row row-text align-items-center" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "row row-text align-items-center mb-4"
}
const _hoisted_22 = { class: "col-auto ms-5" }
const _hoisted_23 = { class: "row row-material-symbol-title align-items-center" }
const _hoisted_24 = { class: "col-auto" }
const _hoisted_25 = { class: "h5 mb-0" }
const _hoisted_26 = { class: "col-auto" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "row row-text align-items-center mb-4"
}
const _hoisted_30 = { class: "col-auto ms-5" }
const _hoisted_31 = { class: "row row-material-symbol-title align-items-center" }
const _hoisted_32 = { class: "col-auto" }
const _hoisted_33 = { class: "h5 mb-0" }
const _hoisted_34 = { class: "col-auto" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "row row-link" }
const _hoisted_38 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_AdvancedPanelSwitcher = _resolveComponent("AdvancedPanelSwitcher")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AdvancedPanel = _resolveComponent("AdvancedPanel")!
  const _component_PreviewMaterialSymbol = _resolveComponent("PreviewMaterialSymbol")!
  const _component_MaterialSymbolInputComponent = _resolveComponent("MaterialSymbolInputComponent")!
  const _component_PageLinkPicker = _resolveComponent("PageLinkPicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("section", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.contentBlock.button.button_layout_code,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.button.button_layout_code) = $event)),
                      options: _ctx.btnLayoutOptions,
                      label: _ctx.$t('layout'),
                      name: "buttonLayout",
                      selectText: _ctx.$t('selectText'),
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_AdvancedPanelSwitcher, {
                      class: "mb-3",
                      "is-advanced": _ctx.isAdvancedButtonText,
                      errors: _ctx.errors,
                      onToggleAdvanced: _ctx.toggleAdvancedButtonText
                    }, null, 8, ["is-advanced", "errors", "onToggleAdvanced"])
                  ]),
                  _createVNode(_component_AdvancedPanel, {
                    "is-show-when-advanced": false,
                    "is-advanced": _ctx.isAdvancedButtonText,
                    class: "col"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.contentBlock.button.button_text.nl,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                        label: _ctx.$t('buttonText'),
                        name: "buttonText",
                        placeholder: "buttonText",
                        rules: "required|max:100",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "label", "errors"])
                    ]),
                    _: 1
                  }, 8, ["is-advanced"]),
                  _createVNode(_component_AdvancedPanel, {
                    "is-show-when-advanced": true,
                    "is-advanced": _ctx.isAdvancedButtonText,
                    class: "col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (_ctx.contentBlock.button.symbol_left)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_PreviewMaterialSymbol, {
                                  "material-symbol": _ctx.contentBlock.button.symbol_left
                                }, null, 8, ["material-symbol"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("button", {
                                  class: "btn btn-icon btn-sm btn-dark mb-3",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addMaterialSymbolLeft && _ctx.addMaterialSymbolLeft(...args)))
                                }, _hoisted_14)
                              ]))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.contentBlock.button.button_text.nl,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                            label: _ctx.$t('buttonText'),
                            name: "buttonText",
                            placeholder: "buttonText",
                            rules: "required|max:100",
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          (_ctx.contentBlock.button.symbol_right)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_PreviewMaterialSymbol, {
                                  "material-symbol": _ctx.contentBlock.button.symbol_right
                                }, null, 8, ["material-symbol"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("button", {
                                  class: "btn btn-icon btn-sm btn-dark mb-3",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addMaterialSymbolRight && _ctx.addMaterialSymbolRight(...args)))
                                }, _hoisted_20)
                              ]))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["is-advanced"])
                ]),
                _createVNode(_component_AdvancedPanel, {
                  "is-show-when-advanced": true,
                  "is-advanced": _ctx.isAdvancedButtonText,
                  class: "bg-light pt-3 ms-3 mb-3"
                }, {
                  default: _withCtx(() => [
                    (_ctx.contentBlock.button.symbol_left)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('symbolLeft')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  class: "btn btn-link text-danger",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteMaterialSymbolLeft && _ctx.deleteMaterialSymbolLeft(...args)))
                                }, _hoisted_28)
                              ])
                            ]),
                            (_ctx.contentBlock.button.symbol_left)
                              ? (_openBlock(), _createBlock(_component_MaterialSymbolInputComponent, {
                                  key: 0,
                                  modelValue: _ctx.contentBlock.button.symbol_left,
                                  errors: _ctx.errors,
                                  name: "symbol_left",
                                  "onUpdate:modelValue": _ctx.onMaterialSymbolLeftUpdate
                                }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.contentBlock.button.symbol_right)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('symbolRight')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  class: "btn btn-link text-danger",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteMaterialSymbolRight && _ctx.deleteMaterialSymbolRight(...args)))
                                }, _hoisted_36)
                              ])
                            ]),
                            (_ctx.contentBlock.button.symbol_right)
                              ? (_openBlock(), _createBlock(_component_MaterialSymbolInputComponent, {
                                  key: 0,
                                  modelValue: _ctx.contentBlock.button.symbol_right,
                                  "show-external-info": false,
                                  errors: _ctx.errors,
                                  name: "symbol_right",
                                  "onUpdate:modelValue": _ctx.onMaterialSymbolRightUpdate
                                }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["is-advanced"]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_PageLinkPicker, {
                      "enable-no-link": _ctx.cbType !== 'PAGE_CONTENT_CALL_TO_ACTION',
                      payload: _ctx.pageLinkPayload,
                      errors: _ctx.errors,
                      onChanged: _ctx.onPageLinkPickerChanged
                    }, null, 8, ["enable-no-link", "payload", "errors", "onChanged"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}